import {
	CollectionType,
	ReturnOrderStatus,
	CustomerOrderType,
	VehicleServiceStatus,
	RepairOrderStatus,
	ExportStatus,
	VehicleAssessmentDamageType, LeasmanContractDepreciationCalculationType, LeasmanAccidentDamage
} from "./Domain";

export const translateReturnOrderDeliveryType = (value: string) => {
	switch (value) {
		case "CustomEntry":
			return "Freie Eingabe";
		case "RebuyerAddress":
			return "RKV-Geberadresse";
		case "UsedCars":
			return "Gebrauchtwagenplatz";
		case "CustomerDelivery":
			return "Eigenanlieferung";
		case "Neuss":
			return "ATN Neuss";
		default:
			return value;
	}
};

export const translateReturnOrderTireType = (value: string) => {
	switch (value) {
		case "gjr":
			return "Ganzjahresreifen";
		case "sr":
			return "Sommerreifen";
		case "wr":
			return "Winterreifen";
		case "unk":
			return "Unbekannt";
		default:
			return value;
	}
};

export const translateReturnOrderStatus = (value: ReturnOrderStatus): string => {
	switch (value) {
		case "Created":
			return "Erstellt";
		case "Processed":
			return "Verarbeitet";
		case "Cancelled":
			return "Storniert";
		case "Imported":
			return "In Bearbeitung";
		case "Assigned":
			return "Zugewiesen";
		case "CustomerCreated":
			return "Kundeneingabe";
		case "Approved":
			return "Bestätigt";
		case "Terminated":
			return "Ausgesetzt";
		default:
			return value;
	}
};

export const translateCollectionType = (value: CollectionType): string => {
	switch (value) {
		case "CustomEntry":
			return "Freie Eingabe";
		case "CustomersAddress":
			return "Kundenadresse";
		case "DriversAddress":
			return "Fahreradresse";
		case "TraderAddress":
			return "Händleradresse";
		case "CustomerDelivery":
			return "Eigenanlieferung";
		case "UsedCars":
			return "Gebrauchtwagenplatz";
		default:
			return value;
	}
};

export const translateCustomerOrderType = (value: CustomerOrderType): string => {
	switch (value) {
		case "Return":
			return "Abholung";
		case "CustomerDelivery":
			return "Eigenanlieferung";
		case "PricingRequest":
			return "Kaufpreisanfrage";
		default:
			return value;
	}
};

export const translateVehicleServiceStatus = (status: VehicleServiceStatus) =>
	({
		Created: "Erstellt",
		Requested: "Angefragt",
		Rejected: "Abgewiesen",
		Cancelled: "Abgebrochen",
		Assigned: "Zugewiesen",
		Started: "Gestartet",
		Completed: "Fertiggestellt",
		Billed: "Abgerechnet"
	})[status];

export const translateRepairOrderStatus = (status: RepairOrderStatus) =>
	({
		Created: "Erstellt",
		Assignable: "Zuweisbar",
		Assigned: "Zugewiesen",
		Ordered: "Beauftragt",
		CostEstimated: "KVA vorhanden",
		Completed: "Abgeschlossen",
		Cancelled: "Storniert"
	})[status];

export const translateVehicleAssessmentDamageType = (type: VehicleAssessmentDamageType) => ({
	Mercantile: "Merkantile Minderung aus Vorschäden",
	Others: "Weitere Wertbeeinflussende Faktoren",
	MissingParts: "Fehlende Teile",
	Damage: "Schaden",
	Tires: "Reifen"
})[type];

export const translateExportStatus = (status: ExportStatus) => ({
	AwaitingDocuments: "Dokumente erwartet",
	ReadyForApproval: "Bereit zur ersten Bestätigung",
	FirstApproval: "Erste Bestätigung erteilt",
	SecondApproval: "Zweite Bestätigung erteilt",
	Rejected: "Abgelehnt",
	Cancelled: "Storniert",
	Reclassified: "Umgestuft"
})[status];

export const translateDamageCatalog = (value: string): string => {
	switch (value) {
		case "PFWT":
			return "PKW Fair Wear and Tear";
		case "LFWT":
			return "LCV Fair Wear and Tear";
		case "VMFF":
			return "VMF - Die faire Fahrzeugbewertung";
		case "PSKA":
			return "PKW Schadenkatalog";
		case "LSKA":
			return "LCV Schadenkatalog";
		case "FASS":
			return "Framework Agreement SAP SE";
		default:
			return value;
	}
};

export const translateDepreciationCalculationType = (type: LeasmanContractDepreciationCalculationType) => ({
	MWTA: "Minderwerttabelle",
	MWTI: "Minderwerttabelle international",
	AWEF: "Abwertungsformel",
	MIWM: "Minderwertmatrix",
	FASS: "Framework Agreement SAP SE"
})[type];
